import { WorkingDay } from './../../models/locations/workingDay.model';
import { WeekDay } from './../../enums/weekDays';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: true,
  name: 'openNow'
})
export class OpenNowPipe implements PipeTransform {
  transform(workingDays: WorkingDay[]): string {
    const dateNow = moment(new Date());
    const workingDay = workingDays.find(
      x => x.day.toUpperCase() === WeekDay[dateNow.day()]
    );

    if (!workingDay) {
      return 'Closed';
    }
    const dateNowHour = dateNow.hour();
    const dateNowMinutes = dateNow.minutes();
    if (
      workingDay.start.hour <= dateNowHour &&
      dateNowHour < workingDay.end.hour
    ) {
      return (
        'Open - Closes ' +
        workingDay.end.hourAsString +
        ':' +
        workingDay.end.minutesAsString
      );
    } else if (
      (workingDay.start.minutes < dateNowMinutes &&
        dateNowMinutes < workingDay.end.minutes) ||
      (dateNowHour <= workingDay.end.hour &&
        dateNowMinutes < workingDay.end.minutes)
    ) {
      return (
        'Open - Closes ' +
        workingDay.end.hourAsString +
        ':' +
        workingDay.end.minutesAsString
      );
    } else {
      return 'Closed';
    }
  }
}
